import { type ParentComponent, Show } from "solid-js";

interface BlockContentContainerProps {
  hasContent: boolean;
}

export const BlockContentContainer: ParentComponent<BlockContentContainerProps> = (props) => {
  return (
    <Show when={props.hasContent}>
      <div class="mt-3 ml-6 text-sm dark:text-gray-300">{props.children}</div>
    </Show>
  );
};
